import { darkTheme } from "~/composables/useGetStyleFromTheme";

export default defineNuxtPlugin(() => {
  const darkThemeStyle = `body { background-color: ${darkTheme["background-1"]}; }`;

  const route = useRoute();

  if (route.query.theme === "dark") {
    const style = document.createElement("style");
    style.innerHTML = darkThemeStyle;

    document.getElementsByTagName("head")[0]?.appendChild(style);
  }
});
